'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _debounce2 = require('lodash/debounce');
var _debounce3 = _interopRequireDefault(_debounce2);
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _debug = require('debug');
var _debug2 = _interopRequireDefault(_debug);
var _events = require('events');
var _events2 = _interopRequireDefault(_events);
var _actions = require('./actions');
var _ActionMutationObserver = require('./ActionMutationObserver');
var _ActionMutationObserver2 = _interopRequireDefault(_ActionMutationObserver);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var record_log = (0, _debug2.default)('replay-browser-events:record');
var event_log = (0, _debug2.default)('replay-browser-events:event');
var INPUT_TARGET_NAMES = ['SELECT', 'OPTION', 'TEXTAREA'];
var BrowserRecorder = function (_EventEmitter) {
  _inherits(BrowserRecorder, _EventEmitter);
  function BrowserRecorder(target) {
    _classCallCheck(this, BrowserRecorder);
    var _this = _possibleConstructorReturn(this, (BrowserRecorder.__proto__ || Object.getPrototypeOf(BrowserRecorder)).call(this));
    _this.debounceDetectRegionMutation = (0, _debounce3.default)(_this.detectRegionMutation.bind(_this), 500);
    _this.target = target;
    _this.document = _this.target.ownerDocument || _this.target;
    _this.installedListeners = [];
    _this.observer = null;
    _this.mutations = [];
    _this.actions = [];
    _this.lastMouseEvents = {};
    // Order of those events is important and taken from:
    // https://www.w3.org/TR/uievents/#events-mouseevent-event-order
    _this.mouseEvents = ['mouseout', 'mouseleave', 'mouseover', 'mouseenter', 'mousemove'];
    _this.on('newaction', function (action) {
      return _this.actions.push(action);
    });

    // capture the scroll event, emit before other new actions
    _this.lastScrollEvent = null;
    _this.on('before-newaction', function (action) {
      if (action && action.constructor.displayName !== 'ScrollAction' && _this.lastScrollEvent) {
        // directly emit newaction, to insert the ScrollAction before the action about to submit
        _this.emit('newaction', _actions.EventAction.fromEvent(_this.document, _this.lastScrollEvent));
        _this.lastScrollEvent = null;
      }
      // actions will emit through newaction after
      _this.emit('newaction', action);
    });
    return _this;
  }
  _createClass(BrowserRecorder, [{
    key: 'addEventListener',
    value: function addEventListener(target, event, listener) {
      var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      target.addEventListener(event, listener, useCapture);
      this.installedListeners.push([target, event, listener, useCapture]);
    }
  }, {
    key: 'clearListeners',
    value: function clearListeners() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;
      try {
        for (var _iterator = this.installedListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 4),
            target = _step$value[0],
            _event = _step$value[1],
            listener = _step$value[2],
            useCapture = _step$value[3];
          target.removeEventListener(_event, listener, useCapture);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      this.installedListeners = [];
    }
  }, {
    key: 'recordEvents',
    value: function recordEvents() {
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['click', 'scroll', 'change'];
      var mouseEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.mouseEvents;
      var _this2 = this;
      var keyCodeFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [13];
      var mutationObserver = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true
      };
      record_log('start record', events, 'events');
      this.firstEvent = true;
      keyCodeFilter = new Set([].concat(_toConsumableArray(keyCodeFilter)));
      events && events.forEach(function (eventName) {
        if (eventName === 'change') {
          // contentEditable will not fire change event, use blur instead
          _this2.addEventListener(_this2.target, 'keyup', function (event) {
            if (!event.target.isContentEditable) return;
            if (event.target._oldContent !== undefined) return;
            event.target._oldContent = event.target.innerHTML;
            _this2.addEventListener(event.target, 'blur', function (event) {
              if (event.target.innerHTML != event.target._oldContent) {
                event.target._oldContent = event.target.innerHTML;
                _this2.onEvent('contentedit', event);
              }
            });
          });
          // trigger input change event if stop enter for 1 seconds
          _this2.addEventListener(_this2.target, 'keyup', (0, _debounce3.default)(function (event) {
            if (event.target !== (_this2.target.ownerDocument || _this2.target).activeElement) return;
            if (event.target.tagName === 'INPUT' || event.target.isContentEditable) {
              event.target.blur();
              event.target.focus();
            }
          }, 2000), true);
        }
        _this2.addEventListener(_this2.target, eventName, _this2.onEvent.bind(_this2, eventName), true);
      });
      mouseEvents && mouseEvents.forEach(function (eventName) {
        _this2.addEventListener(_this2.target, eventName, function (event) {
          return _this2.lastMouseEvents[eventName] = event;
        }, true);
      });
      if (keyCodeFilter && keyCodeFilter.size && !events.includes('keypress')) {
        this.addEventListener(this.target, 'keypress', function (event) {
          if (!keyCodeFilter.has(event.which)) return;
          // KeyAction might play on an input, sometimes it's fired before input change
          // setTimeout will postpone the action fired to wait for InputChangeAction
          setTimeout(function () {
            _this2.onEvent('key', event); // use a special eventName to dispatch a KeyAction instead of KeyboardAction
          }, 0);
        }, true);
      }
      this.observer = new _ActionMutationObserver2.default();
      this.observer.observe(this.target, mutationObserver);
      // blackList 1 seconds later for performance
      setTimeout(function () {
        if (_this2.firstEvent) _this2.observer.blackListRecords();
      }, 1000);
    }
  }, {
    key: 'stopRecord',
    value: function stopRecord() {
      var result = this.takeRecords();
      this.clearListeners();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      return result;
    }
  }, {
    key: 'takeRecords',
    value: function takeRecords() {
      var result = null;
      if (this.actions.length) {
        result = new _actions.FlowControlAction(this.document, this.actions);
      }
      this.actions = [];
      return result;
    }
  }, {
    key: 'onEvent',
    value: function onEvent(eventName, event) {
      var _this3 = this;

      // Ignore click events for some input elements
      if (eventName === 'click' && INPUT_TARGET_NAMES.includes(event.target.tagName)) {
        return;
      }

      // keep update the last scroll event, and emit it when anyother event happened
      if (eventName === 'scroll') {
        this.debounceDetectRegionMutation(); // still need to detectRegionMutation triggered by scroll, but need debounce
        this.lastScrollEvent = event;
        return;
      }

      // onEvent is called before event actually triggered
      // detectRegionMutation will record the changes before current action
      this.detectRegionMutation();
      var action = void 0;

      // Handle click on captcha
      if (eventName === 'click' && [].concat(_toConsumableArray(event.target.classList)).includes('captcha-state-handler')) {
        action = _actions.CaptchaAction.fromClickEvent(this.document, event);
      } else if (eventName === 'contentedit') {
        action = new _actions.ContentEditAction(this.document, event);
      } else if (eventName === 'key') {
        // special KeyAction, combined with keydown + keypress + keyup
        action = new _actions.KeyAction(this.document, _actions.EventAction.fromEvent(this.document, event));
      } else {
        action = _actions.EventAction.fromEvent(this.document, event);
      }
      event_log('event', eventName, event, action);
      this.emit('before-newaction', action);

      // Observer might be null by now.
      setTimeout(function () {
        return _this3.observer && _this3.observer.takeRecords();
      }, 1); // dont' record immediately changes
    }

    /**
     * emit WaitRegionMutationAction if region changes detected
     * @return true if activeRegion detected
     */
  }, {
    key: 'detectRegionMutation',
    value: function detectRegionMutation() {
      // This function might be called in the debounced callback, where this.observer was already removed.
      // To prevent errors happening because of that, just checking if observer is available before making the call.
      if (this.observer) {
        if (this.firstEvent) {
          this.observer.blackListRecords();
          this.firstEvent = false;
        } else {
          var mutations = this.observer.takeRecords();
          var activeRegion = this.observer.getMostActiveRegion(mutations);
          if (activeRegion) {
            var action = new _actions.WaitRegionMutationAction(this.document, activeRegion, this.observer.options);
            event_log('mutation-event', action);
            this.emit('before-newaction', action);
            return true;
          }
        }
      }
    }
  }, {
    key: 'triggerHoverEvent',
    value: function triggerHoverEvent() {
      var _this4 = this;
      var eventName = '__hover__';
      this.detectRegionMutation();
      var eventActions = this.mouseEvents.map(function (eventName) {
        return _this4.lastMouseEvents[eventName];
      }).filter(function (event) {
        return event !== undefined;
      }).map(function (event) {
        return _actions.EventAction.fromEvent(_this4.document, event);
      });
      var flowControlAction = new _actions.HoverAction(this.document, eventActions);
      event_log('event', eventName, event, flowControlAction);
      this.emit('before-newaction', flowControlAction);
      this.lastMouseEvents = {};
      setTimeout(function () {
        return _this4.observer.takeRecords();
      }, 1); // dont' record immediately changes
    }
  }]);

  return BrowserRecorder;
}(_events2.default);
BrowserRecorder.displayName = 'BrowserRecorder';
exports.default = BrowserRecorder;